export default __webpack_public_path__ + "static/media/robot-rock.1937b43e.svg";